import type { RouteRecordRaw } from 'vue-router'

export default (): RouteRecordRaw[] => {
  if (!import.meta.dev) return []

  return [
    {
      path: 'dev/browsing-history',
      name: 'dev-browsing-history',
      component: () =>
        import('~/scopes/browsing-history/pages/DevHarness/DevHarness.vue'),
      meta: {
        owners: ['bot-squad-search-and-recommendation-front'],
      },
    },
  ]
}
